// @flow

const getApiMetaErrors = (meta: Object): string =>
  Object.values(meta)
    .reduce((acc, cur) => acc.concat(cur), [])
    .join(", ");

export default getApiMetaErrors;
